import { Tooltip } from '@material-ui/core'
import { head, last } from '@soltalabs/ramda-extra'
import moment from 'moment'
import React from 'react'

import { StyledSlider, StyledLinearProgress } from './styles'

import { styled, s } from 'lib/styled'
import { deepMemo } from 'utils/react'

const Root = styled.div(s('h-4'))

const sliderValueText = (time) => {
  return moment.unix(time).format('ddd Do MMM HH:mm')
}

const ValueLabelComponent = (props) => {
  const { children, open, value } = props

  const popperRef = React.useRef(null)
  React.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update()
    }
  })

  return (
    <Tooltip
      PopperProps={{
        popperRef,
      }}
      open={open}
      enterTouchDelay={0}
      placement="top"
      title={value}
    >
      {children}
    </Tooltip>
  )
}

const computeMarks = (forecastStartTimes) => {
  const marks = []
  const startDate = moment(head(forecastStartTimes)).unix()

  for (let index = 0; index <= 2; index += 1) {
    const date = moment.unix(startDate).add(index, 'days')
    marks.push({
      value: date.unix(),
      label: date.format('ddd'),
    })
  }

  const endDate = moment(last(forecastStartTimes))

  marks.push({
    value: endDate.unix(),
    label: endDate.format('ddd'),
  })

  return marks
}

function View({ forecastStartTimes, isLoadingSlider, onSliderValueChange }) {
  if (isLoadingSlider) {
    return (
      <Root>
        <StyledLinearProgress />
      </Root>
    )
  }

  const minTimestamp = moment(head(forecastStartTimes)).unix()
  const maxTimestamp = moment(last(forecastStartTimes)).unix()

  return (
    <Root>
      <StyledSlider
        defaultValue={moment(head(forecastStartTimes)).unix()}
        valueLabelDisplay="auto"
        valueLabelFormat={sliderValueText}
        onChange={onSliderValueChange}
        step={3600}
        marks={computeMarks(forecastStartTimes)}
        min={minTimestamp}
        max={maxTimestamp}
        ValueLabelComponent={ValueLabelComponent}
      />
    </Root>
  )
}

const ForecastSliderView = deepMemo(View)

export { ForecastSliderView }
